import React, { Component, ReactNode } from 'react';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
interface IReorderComponentProps<ChildContainerProps, OrderedItem> {
  readonly orderedItems: ReadonlyArray<OrderedItem>;

  readonly onOrderedItemsChange: (
    items: ReadonlyArray<OrderedItem>,
    fromtIndex: number,
    toIndex: number,
  ) => void;

  readonly renderOrderedItems: (
    items: ReadonlyArray<OrderedItem>,
    changeItemOrder: (fromIndex: number, toIndex: number) => void,
  ) => ReactNode;
}

function isValidArrayIndex({ length }: ReadonlyArray<any>, index: number) {
  return index >= 0 && index < length;
}

export function shiftElements<T>(
  array: ReadonlyArray<T>,
  fromIndex: number,
  toIndex: number,
): ReadonlyArray<T> {
  const arrayCopy = [...array];

  if (
    isValidArrayIndex(array, fromIndex) &&
    isValidArrayIndex(array, toIndex)
  ) {
    const fromElement = arrayCopy[fromIndex];
    arrayCopy.splice(fromIndex, 1);
    arrayCopy.splice(toIndex, 0, fromElement);
    return arrayCopy;
  }

  return arrayCopy;
}

export default class ReorderComponent<
  ChildContainerProps,
  OrderedItem,
> extends Component<IReorderComponentProps<ChildContainerProps, OrderedItem>> {
  render() {
    const { orderedItems, onOrderedItemsChange, renderOrderedItems } =
      this.props;

    return (
      <>
        {renderOrderedItems(orderedItems, (fromIndex, toIndex) => {
          const newItems = shiftElements(orderedItems, fromIndex, toIndex);
          onOrderedItemsChange(newItems, fromIndex, toIndex);
        })}
      </>
    );
  }
}
